// extracted by mini-css-extract-plugin
export default {"test":"paymentoffer_test__tEq75","inner":"paymentoffer_inner__-QuiQ"};